import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = ({ pieAlert }) => {
  const data = {
    labels: ["New", "Assigned", "Closed"],
    datasets: [
      {
        label: "Tickets",
        data: pieAlert,
        backgroundColor: [
          "#8EE0DE", // New
          "#59D98E", // Assigned
          "#FF6B6B", // Closed
        ],
        borderWidth: 1, // ✅ remove slice borders
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "top",
      },
    },
  };

  return (
    <div style={{ height: "300px", width: "100%" }}>
      <Pie data={data} options={options} />
    </div>
  );
};

export default PieChart;
